import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import i18n from 'i18next'
import Modal from '../../UniformComponents/Modal'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'
import ModalFooter from '../../UniformComponents/ModalFooter'
import ModalHeader from '../../UniformComponents/ModalHeader'
import Checkbox from '../form/Checkbox'
import Select from '../form/Select'

@observer
class CreateTemplateModal extends Component {
    constructor(props) {
        super(props)
        const { editingTemplate, dashboard } = props.dashStore
        let defaultTemplateSettings = {
            setAsTemplate: false,
            industry: undefined,
            productType: undefined,
            surveyType: undefined,
            dashboardName: '',
            description: '',
            metrics: [''],
        }

        if (editingTemplate) {
            const { widgets: { templateSettings } } = dashboard
            defaultTemplateSettings = { ...templateSettings, metrics: R.pathOr([''], ['metrics'], templateSettings) }
        }

        this.state = {
            ready: false,
            productMap: {},
            templateSettings: defaultTemplateSettings,
        }
        this.init()
    }

    init = async () => {
        const productMap = await this.getProdMap()
        this.setState({ ready: true, productMap })
    }

    getProdMap = async () => {
        const { dashStore } = this.props
        const { appStore } = dashStore
        const { clientId } = appStore.userData
        const productMaps = await appStore.http.get(`/productmap/${clientId}`)
        const prodMap = productMaps.reduce((obj, m) => {
            const newObj = { ...obj }
            // eslint-disable-next-line max-len
            newObj[m.industrycode] = newObj[m.industrycode] || { label: m.industryname, value: m.industrycode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode] = newObj[m.industrycode].children[m.producttypecode]
            || { label: m.producttypename, value: m.producttypecode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode] = newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode]
            || { label: m.surveytypename, value: m.surveytypecode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode].children[m.respondenttypecode] = newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode].children[m.respondenttypecode]
            || { label: m.respondenttypename, value: m.respondenttypecode }

            return newObj
        }, {})
        return prodMap
    }

    changeSettings = ({ name, value }) => {
        const { templateSettings } = this.state
        if (name === 'industry') {
            this.setState({
                templateSettings: {
                    ...templateSettings,
                    productType: '',
                    surveyType: '',
                    [name]: value,
                },
            })
        } else if (name === 'productType') {
            this.setState({
                templateSettings: {
                    ...templateSettings, surveyType: '', [name]: value,
                },
            })
        } else {
            this.setState({ templateSettings: { ...templateSettings, [name]: value } })
        }
    }

    changeMetrics = ({ name, value }) => {
        const index = name.split('-')[1]
        const { templateSettings } = this.state
        const newMetrics = [...templateSettings.metrics]
        newMetrics[index] = value
        this.setState({ templateSettings: { ...templateSettings, metrics: newMetrics } })
    }

    removeMetric = (index) => {
        const { templateSettings } = this.state
        const newMetrics = [...templateSettings.metrics]
        newMetrics.splice(index, 1)
        this.setState({ templateSettings: { ...templateSettings, metrics: newMetrics } })
    }

    save = () => {
        const { dashStore } = this.props
        const {
            createNewDashboard,
            toggleShowCreateTemplateModal,
            editingTemplate,
            toggleEditingTemplate,
            dashboard,
            saveDashboard,
        } = dashStore
        const { templateSettings } = this.state
        if (editingTemplate) {
            dashboard.widgets.templateSettings = templateSettings
            saveDashboard()
            toggleEditingTemplate()
        } else {
            createNewDashboard(templateSettings.dashboardName, true, true, templateSettings)
        }
        toggleShowCreateTemplateModal()
    }

    close = () => {
        const { dashStore } = this.props
        const { toggleShowCreateTemplateModal, editingTemplate, toggleEditingTemplate } = dashStore
        this.setState({
            templateSettings: {
                setAsTemplate: false,
                industry: undefined,
                productType: undefined,
                surveyType: undefined,
                description: '',
                metrics: [],
            },
        })
        if (editingTemplate) {
            toggleEditingTemplate()
        }
        toggleShowCreateTemplateModal()
    }

    render() {
        const { dashStore } = this.props
        const {
            showCreateTemplateModal,
        } = dashStore
        const { templateSettings, ready, productMap } = this.state
        const {
            setAsTemplate, industry, productType, surveyType, description, metrics, dashboardName,
        } = templateSettings
        const valid = productType && surveyType && industry && dashboardName

        const industries = Object.values(productMap)
        const productTypes = Object.values(R.pathOr({}, [industry, 'children'], productMap))
        const surveyTypes = Object.values(R.pathOr({}, [industry, 'children', productType, 'children'], productMap))

        return (
            <Modal
                show={showCreateTemplateModal}
                onClose={this.close}
                cssClass="createTemplateModal"
            >
                <ModalHeader>
                    <div className="title">
                        {i18n.t('dashboards.createTemplate.title')}
                    </div>
                </ModalHeader>
                {ready ? (
                    <div className="body">
                        <div style={{ marginBottom: '10px' }}>
                            <Checkbox
                                label={i18n.t('dashboards.createTemplate.setAsTemplate')}
                                name="setAsTemplate"
                                onBlur={this.changeSettings}
                                checked={setAsTemplate}
                            />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <Select
                                label={i18n.t('industry')}
                                name="industry"
                                options={industries}
                                value={industries.find((ind) => industry === R.pathOr('', ['value'], ind)) || ''}
                                onBlur={this.changeSettings}
                                blurOnClear
                            />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <Select
                                label={i18n.t('product_type')}
                                name="productType"
                                onBlur={this.changeSettings}
                                options={productTypes}
                                value={productTypes.find((prod) => productType === R.pathOr('', ['value'], prod)) || ''}
                                blurOnClear
                                style={{ marginBottom: '10px' }}
                            />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <Select
                                label={i18n.t('survey_type')}
                                name="surveyType"
                                onBlur={this.changeSettings}
                                options={surveyTypes}
                                value={surveyTypes.find((sur) => surveyType === R.pathOr('', ['value'], sur)) || ''}
                                blurOnClear
                                style={{ marginBottom: '10px' }}
                            />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <Input
                                label={i18n.t('dashboard_name')}
                                defaultValue={dashboardName}
                                name="dashboardName"
                                onBlur={this.changeSettings}
                            />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '2px' }}>
                                {i18n.t('dashboards.createTemplate.dashboardDescription')}
                            </p>
                            <textarea
                                style={{ width: '100%', height: '150px' }}
                                value={description}
                                onChange={(e) => this.changeSettings({ name: 'description', value: e.target.value })}
                            />
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', marginBottom: '2px' }}>{i18n.t('add_metrics')}</p>
                            {metrics.map((m, i) => (
                                <div style={{ display: 'flex', marginBottom: '8px', alignItems: 'center' }}>
                                    <Input
                                        defaultValue={R.pathOr('', [i], metrics)}
                                        name={`metric-${i}`}
                                        onBlur={this.changeMetrics}
                                        key={uuidv4()}
                                    />
                                    <i
                                        className="fa-regular fa-circle-xmark"
                                        style={{ marginLeft: '5px', fontSize: '16px', cursor: 'pointer' }}
                                        onClick={() => this.removeMetric(i)}
                                    />
                                </div>
                            ))}
                            <Button
                                label="Add aother metric"
                                onClick={() => this.setState({ templateSettings: { ...templateSettings, metrics: [...metrics, ''] } })}
                            />
                        </div>
                    </div>
                )
                    : null }
                <ModalFooter>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <Button
                            label={(
                                <div>
                                    {i18n.t('cancel')}
                                </div>
                            )}
                            cssClass="tertiary regular"
                            onClick={this.close}
                        />
                        <Button
                            label={(
                                <div>
                                    {i18n.t('save')}
                                </div>
                            )}
                            cssClass="primary regular"
                            style={{ width: '200px', fontWeight: 600, textAlign: 'center' }}
                            onClick={this.save}
                            disabled={!valid}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateTemplateModal
